import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';

/**
 * Mixin KO
 */
export const koMixin = {
  computed: {
    ...mapState({
      koConfig(state) {
        if (state.setting.settings[PublicSettings.PAYMENT_LIST_CONFIG]?.value) {
          return JSON.parse(state.setting.settings[PublicSettings.PAYMENT_LIST_CONFIG].value);
        }
        return {};
      }
    }),

    koEnabled() {
      return this.koConfig.enableKo;
    }
  }
};
